<template>
  <div>
    <v-card>
      <div class="pa-3 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9"> </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="data"
        item-key="name"
        class="elevation-3 mb-3 historic-bet"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        :single-select="false"
        :show-select="result == 2"
        :items-per-page="result == 2 ? -1 : 10"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id_sale="{ item }">
          <v-btn @click="$copy(item.id_sale)" x-small>
            {{ item.id_sale }}
          </v-btn>
        </template>
        <template v-slot:item.id_vendedor="{ item }">
          <v-btn @click="$copy(item.id_vendedor)" x-small>
            {{ item.id_vendedor }}
          </v-btn>
        </template>

        <template v-slot:item.status_sales="{ item }">
          <v-icon :color="colorStatus(item.status_sales)" size="16">
            mdi-circle
          </v-icon>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn-toggle dense>
            <v-btn small title="Cancelar Crédito" @click="confirm(item)">
              <v-icon size="24">mdi-cancel</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "administrator-bet-cancel",
  props: ["enableTabs"],
  data: () => ({
    data: [],
    search: "",
    selected: [],
    result: 4,
    tabCancel: false,
    dataCancelament: {},
  }),

  computed: {
    headers() {
      return [
        // ocultos para tratamentos (nao altere)
        { text: "Evento Editado", value: "events_edited", align: " d-none" },
        { text: "Valor_some", value: "amount", align: " d-none" },
        { text: "", value: "punter", align: " d-none" },

        // { text: "Pagar", value: "select", sortable: false, align: " d-none" },
        { text: this.$t("code"), value: "id_sale" },
        { text: this.$t("player"), value: "name_player" },
        { text: this.$t("sellerCode"), value: "id_vendedor" },
        { text: this.$t("operation"), value: "name_operation" },
        { text: this.$t("dateTime"), value: "date_sales" },
        { text: this.$t("value"), value: "value_sale" },
        { text: this.$t("commission"), value: "value_comission" },
        { text: this.$t("status"), value: "status_sales", align: "center" },
        { text: this.$t("cancelCredit"), value: "action", align: "" },
      ];
    },
    // ====================================================
    // 2. Retrieve Filters
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    id_player() {
      return this.$store.state.filters.autocompletePlayers.id;
    },
    status() {
      return this.$store.state.filters.groupStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // ====================================================
    // Retrieve Range:
    rangeDate() {
      return this.$store.state.range.date;
    },
    actionConfirm() {
      return this.$store.state.actionConfirm;
    },

    statusCode() {
      return this.$store.state.feedbackSnack.status;
    },
    fetchCreditsUserRetail() {
      return this.$store.getters.getFetchCreditsUserRetail;
    },
  },

  watch: {
    fetchCreditsUserRetail(val) {
      if (val) {
        this.getPlayerCredits();
      }
    },
    // saveFilters(val) {
    //   // Este IF evita uma consulta desnecessária em
    //   // '/administrator/users/players/search/listPlayerBets'
    //   if (this.enableTabs == 2) val && this.getPlayerCredits();
    // },

    actionConfirm(val) {
      val && this.cancelCredit();
    },
  },

  methods: {
    async getPlayerCredits() {
      if (!this.id_player) {
        this.playerIsRequired();
        return;
      }

      const body = {
        ...this.rangeDate,
        id_regional: this.id_regional || "",
        id_local: this.id_local || "",
        id_agente: this.id_agent || "",
        id_jogador: this.id_player || "",
        status: this.status,
      };

      const request = await this.$request.post(
        "administrator/credits/historicSales",
        body
      );
      this.rowsPerPageItems = request.length;
      this.data = request.length == 0 ? [] : request.dados;

      // Tratament date
      this.data = this.data.map((item) => {
        item.date_sales = new Date(
          item.date_sales.replace(" ", "T")
        ).toLocaleString();
        return item;
      });

      // Show/Hide button cancel
      const colAction = this.headers[this.headers.length - 1];
      this.status == 1 ? (colAction.align = "") : (colAction.align = " d-none");

      this.$store.commit("setFetchCreditsUserRetail", false);
    },

    confirm(data) {
      this.dataCancelament = data;
      const { id_sale, name_player } = data;
      this.$store.commit("setFeedbackDialog", {
        title: "Atenção",
        msg: `${this.$t("msgConfirmCancelCredit")} ${name_player}, ${this.$t(
          "code"
        )}: ${id_sale}?`,
        type: "warning",
        action: "confirm",
      });
    },

    async cancelCredit() {
      const { id_sale, id_player } = this.dataCancelament;
      const request = await this.$request.post(
        "/administrator/credits/cancelCredit",
        { id_sale, id_player }
      );

      // Se o conteúdo de dados do request for diferente de zero, entra no if
      // filtra o item pelo id, encontra o index e remove o item;
      // Se for igual a zero, ignora o if. Status de erro é tratado
      // no plugin-request
      if (request.length != 0) {
        this.data.filter((item, index) => {
          if (item.id_sale == id_sale) {
            this.data.splice(index, 1);
          }
        });

        this.$store.commit("setFeedbackSnack", {
          msg: request.messages,
          color: "success",
        });
      }

      this.$store.commit("setActionConfirm", false);
    },

    colorStatus(status) {
      if (status == 0) return "purple";
      if (status == 1) return "green";
    },
    playerIsRequired() {
      this.$store.commit("setFetchCreditsUserRetail", false);
      this.$store.commit("setFeedbackSnack", {
        msg: this.$t("playerNameIsRequired"),
        color: "warning",
      });
      this.$store.commit("setSave", false);
      this.$store.commit("DisabledSave", false);
    },
  },
};
</script>
<style>
/* Oculta no mobile 'events_edited' e 'Valor_some' */
.historic-bet.v-data-table tbody td:last-child {
  height: 56px !important;
}
.historic-bet td.v-data-table__mobile-row:nth-child(1),
.historic-bet td.v-data-table__mobile-row:nth-child(2),
.historic-bet td.v-data-table__mobile-row:nth-child(3),
.v-data-table-header-mobile {
  display: none;
}
.historic-bet td.v-data-table__mobile-row:nth-child(4) {
  height: 56px !important;
  font-size: 18px;
}
</style>
